import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./liquidity.scss";
import { useRiskMarketLiquidity } from "./useRiskMarketLiquidity";
import { useGetAllBalances } from "../AllBalances";
import LiquidityLoader from "../../hooks/liquidityLoader";
import { OverlayTrigger } from "react-bootstrap";
import TooltipCustom from "react-bootstrap/Tooltip";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import { useTranslation } from "react-i18next";
import CountdownTimerLiquidity from "./CountDownTimerLiquidity";
import { formatSmartDecimal, formatNumbers, formatNumberWithCommasForRiskmarket, convertFromMweiToFIxed } from "../../utils/helpers";
import { arbiscan_url } from "../../utils/Enviroment";
import LiquidityBanner from "./LiquidityBanner"
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../RecoilAtom";
import { USDT_MOCK_VALUE } from "../../utils/constants";
import Footer from "../Homepage/footer/Footer";
const Liquidity = () => {
    const { t } = useTranslation();
    const { account } = useEoaAccount();
    const smartAccount = useRecoilValue(userSmartAccount);
    const getAllBalances = useGetAllBalances();
    const {
        deposittedHistory,
        withdrawlHistory,
        totalUserWithdrawn,
        allTimeDeposites,
        currentLiquidity,
        distributedRewards,
        userLiquidityShare,
        userLiquidityWorth,
        pendingWitdrawStatus,
        pendingWitdrawAmount,
        gameApy,
        loading,
        smartAccountUsdtBalance,
        fetchDepositedHistory,
        fetchWithdrawldHistory,
        claimedRewardHandler,
        fetchData,
        fetchYourData,
        fetchPlayerBetHistory,
        refreshAllData,
        handleAddLiquidity,
        handleRemoveLiquidity,
        handleClaimRewards,
        handleUnreserve,
        formatTimestamp,
        shortenAddress,
    } = useRiskMarketLiquidity();

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);
    const [show6, setShow6] = useState(false);
    const [show7, setShow7] = useState(false);
    const [show8, setShow8] = useState(false);
    const [show9, setShow9] = useState(false);
    const [show10, setShow10] = useState(false);
    const [show11, setShow11] = useState(false);

    const [liquidityAmount, setLiquidityAmount] = useState("");
    const [removeUserLiquidity, setRemoveUserLiquidity] = useState("");
    const [withdrawalAmount, setWithdrawalAmount] = useState(null);
    const [index, setIndex] = useState(null);
    const [isTimerExpired, setIsTimerExpired] = useState(false);
    const [loaderText, setLoaderText] = useState({
        heading: "Loading",
        paragraph: "",
    });

    const handleClose = () => setShow(false);
    const handleShow = (idx, amount) => {
        setShow(true);
        const formattedAmount = convertFromMweiToFIxed(amount, 'ether');
        setWithdrawalAmount(formattedAmount);
        setIndex(idx);
    };

    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);

    const handleClose2 = () => {
        setShow2(false);
        setShow8(false);
        setTimeout(async () => {
            await refreshAllData();
        }, 3000);
    };
    const handleShow2 = () => setShow2(true);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const handleClose5 = () => {
        setShow5(false);
        setShow8(false);
        setTimeout(async () => {
            await refreshAllData();
        }, 3000);
    };
    const handleShow5 = () => setShow5(true);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);

    const handleClose7 = () => setShow7(false);
    const handleShow7 = () => setShow7(true);

    const handleClose8 = () => {
        setShow8(false);
        setTimeout(async () => {
            await refreshAllData();
        }, 3000);
    };
    const handleShow8 = () => setShow8(true);

    const handleClose9 = () => setShow9(false);
    const handleShow9 = () => setShow9(true);

    const handleClose10 = () => {
        setShow10(false);
        setShow8(false);
        setTimeout(async () => {
            await refreshAllData();
        }, 3000);
    };
    const handleShow10 = () => setShow10(true);

    const handleClose11 = () => setShow11(false);
    const handleShow11 = () => setShow11(true);

    const onAddLiquidity = async () => {
        const betAmount = parseFloat(liquidityAmount);
        await handleAddLiquidity(
            betAmount,
            setLoaderText,
            handleShow8,
            handleClose7,
            getAllBalances,
            setLiquidityAmount
        );
    };

    const onRemoveLiquidity = async () => {
        const BUFFER = USDT_MOCK_VALUE * 0.1;
        const amount = removeUserLiquidity - (USDT_MOCK_VALUE + BUFFER);
        await handleRemoveLiquidity(
            amount,
            setLoaderText,
            handleShow5,
            handleClose4,
            getAllBalances,
            setRemoveUserLiquidity
        )
    };

    const onClaimRewards = async () => {
        await handleClaimRewards(setLoaderText, handleShow10, handleClose9);
    };

    const onUnreserve = async () => {
        await handleUnreserve(setLoaderText, handleClose1, handleShow2, refreshAllData);
    };

    useEffect(() => {
        const initialData = async () => {
            await fetchDepositedHistory();
            await fetchWithdrawldHistory();
            await claimedRewardHandler();
            await fetchYourData();
        };
        if (smartAccount) {
            initialData();
        }
    }, [smartAccount, fetchDepositedHistory, fetchWithdrawldHistory, claimedRewardHandler, fetchYourData]);

    useEffect(() => {
        const initialData = async () => {
            await fetchData();
            await fetchPlayerBetHistory();
        };
        initialData();
    }, [fetchData, fetchPlayerBetHistory]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {loading && <LiquidityLoader text={loaderText} />}
            <div className="parent-liquidity">
                <LiquidityBanner />
                <div className="custom-container">
                    <section className="liquidity_main">
                        <div className="inner_main">
                            <div className="left_side">
                                <div className="left_top">
                                    <div className="inner_left_side">
                                        <span className="line yellow"></span>
                                        <h2>Total Pool Liquidity</h2>
                                        <h3>${formatNumberWithCommasForRiskmarket(+currentLiquidity)}</h3>
                                    </div>
                                    <div className="inner_right_side">
                                        <span className="line green"></span>
                                        <h2>Total Distributed Rewards</h2>
                                        <h3>${formatNumberWithCommasForRiskmarket(+distributedRewards)}</h3>
                                    </div>
                                    <div className="inner_right_side">
                                        <span className="line blue"></span>
                                        <h2>Estimated APY <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                    <h6>Estimated APY</h6>
                                                    <p>The amount you have added to the liquidity pool.</p>
                                                </TooltipCustom>
                                            }
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <g clipPath="url(#clip0_10136_49160)">
                                                    <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M7 9.33333V7" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M7 4.6665H7.01" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_10136_49160">
                                                        <rect width="14" height="14" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </OverlayTrigger></h2>
                                        <h3>{gameApy > 0 ? `${formatNumberWithCommasForRiskmarket(+gameApy)}` : "0"}%</h3>
                                    </div>
                                </div>
                                <div className="flow_mains">
                                    <div>
                                        <h4>Liquidity Participation</h4>
                                        <p>
                                            Provide liquidity to support market operations and receive protocol-distributed rewards.
                                        </p>
                                    </div>
                                    <div className="parents_innar">
                                        <div className="inar">
                                            <h5>Liquidity Shares
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                            <h6>Liquidity Shares</h6>
                                                            <p>The amount of shares you hold in the liquidity pool, based on the liquidity amount you provided.</p>
                                                        </TooltipCustom>
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <g clipPath="url(#clip0_10136_49160)">
                                                            <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M7 9.33333V7" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M7 4.6665H7.01" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_10136_49160">
                                                                <rect width="14" height="14" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </OverlayTrigger>
                                            </h5>
                                            <h6>
                                                {userLiquidityShare > 0 ? `${formatNumberWithCommasForRiskmarket(+userLiquidityShare)}` : "0"}
                                            </h6>
                                        </div>
                                        <div className="inar">
                                            <h5>Liquidity Worth
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                            <h6>Liquidity Worth</h6>
                                                            <p>The current value of your liquidity, based on the total liquidity available at the moment.</p>
                                                        </TooltipCustom>
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <g clipPath="url(#clip0_10136_49160)">
                                                            <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M7 9.33333V7" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M7 4.6665H7.01" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_10136_49160">
                                                                <rect width="14" height="14" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </OverlayTrigger>
                                            </h5>
                                            <h6>

                                                {userLiquidityWorth > 0 ? `$${formatNumberWithCommasForRiskmarket(+userLiquidityWorth)}` : "0"}
                                            </h6>
                                        </div>
                                        <div className="inar">
                                            <h5>Withdrawn</h5>
                                            <h6>
                                                {totalUserWithdrawn > 0 ? `$${formatNumberWithCommasForRiskmarket(+totalUserWithdrawn)}` : "0"}
                                            </h6>
                                        </div>
                                        <div className="inar">
                                            <h5>Deposits</h5>
                                            <h6>
                                                {allTimeDeposites > 0 ? `$${formatNumberWithCommasForRiskmarket(allTimeDeposites)}` : "0"}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="butttonsdiv" style={!account ? { gridTemplateColumns: "1fr" } : { gridTemplateColumns: "1fr 1fr" }}>
                                        {account && (
                                            <button className="removebutton" onClick={handleShow3}
                                                disabled={userLiquidityShare <= 0 || pendingWitdrawAmount > 0 ? true : false}>
                                                Withdraw My Liquidity
                                            </button>
                                        )}
                                        {account ? (
                                            <>
                                                <button className="addbutton" onClick={handleShow6}
                                                    disabled={smartAccountUsdtBalance <= 0 ? true : false}
                                                >
                                                    Add Liquidity
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                disabled
                                                onClick={handleShow11}
                                                className="claimbutton"
                                            >
                                                Please connect your wallet
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="right__side">
                                <h2>History</h2>
                                <div>
                                    <nav className="navsectiontabs">
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button
                                                className="nav-link active"
                                                id="nav-home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#nav-home"
                                                type="button"
                                                role="tab"
                                                aria-controls="nav-home"
                                                aria-selected="true"
                                            >
                                                Liquidity Deposits
                                            </button>
                                            <button
                                                className="nav-link"
                                                id="nav-contact-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#nav-contact"
                                                type="button"
                                                role="tab"
                                                aria-controls="nav-contact"
                                                aria-selected="false"
                                            >
                                                Liquidity Withdrawals{" "}
                                            </button>
                                        </div>
                                    </nav>
                                    <div className="tab-content" id="nav-tabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="nav-home"
                                            role="tabpanel"
                                            aria-labelledby="nav-home-tab"
                                        >
                                            <div className="table_side">
                                                {window.innerWidth > 991 ? (
                                                    <div className="history-section">
                                                        <div className="parent">
                                                            <div className="upper-fields">
                                                                <p>Date & Time</p>
                                                                <p>Tx Hash</p>
                                                                <p>Amount</p>
                                                            </div>

                                                            <div
                                                                className="bottom-fields"
                                                                style={{ minHeight: "400px" }}
                                                            >
                                                                {account ? (
                                                                    deposittedHistory && deposittedHistory.length > 0 ? (
                                                                        deposittedHistory?.map((row, index) => (
                                                                            <div className="single-field" key={index}>
                                                                                <h6 className="para-color">
                                                                                    {formatTimestamp(row?.blockTimestamp)}
                                                                                </h6>

                                                                                <a
                                                                                    href={`${arbiscan_url}/${row?.transactionHash}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {shortenAddress(row?.transactionHash)}
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="12"
                                                                                        height="12"
                                                                                        viewBox="0 0 12 12"
                                                                                        fill="none"
                                                                                    >
                                                                                        <path
                                                                                            d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                                                                            stroke="#797979"
                                                                                            strokeWidth="1.04"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                        <path
                                                                                            d="M10.5 1.5L6 6"
                                                                                            stroke="#797979"
                                                                                            strokeWidth="1.04"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                        <path
                                                                                            d="M7.5 1.5H10.5V4.5"
                                                                                            stroke="#797979"
                                                                                            strokeWidth="1.04"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                </a>

                                                                                <h6>
                                                                                    $
                                                                                    {formatSmartDecimal(
                                                                                        +convertFromMweiToFIxed(row?.assets)
                                                                                    )}
                                                                                </h6>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <p className="no-data-text">
                                                                            No Liquidity Deposits Yet
                                                                        </p>
                                                                    )
                                                                ) : (
                                                                    <p className="no-data-text" style={{ flexDirection: "column", gap: "25px" }}>
                                                                        <div className="box-svg">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                                                                <path d="M26.916 22.1667H26.9335" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                <path d="M11.0833 11.0833H30.0833C30.9232 11.0833 31.7286 11.417 32.3225 12.0108C32.9164 12.6047 33.25 13.4101 33.25 14.25V30.0833C33.25 30.9232 32.9164 31.7286 32.3225 32.3225C31.7286 32.9164 30.9232 33.25 30.0833 33.25H7.91667C7.07681 33.25 6.27136 32.9164 5.6775 32.3225C5.08363 31.7286 4.75 30.9232 4.75 30.0833V7.91667C4.75 7.07681 5.08363 6.27136 5.6775 5.6775C6.27136 5.08363 7.07681 4.75 7.91667 4.75H30.0833" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </div>
                                                                        Connect your wallet
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="history-section-mbl">
                                                        <div className="parent-cards">
                                                            {account ? (
                                                                deposittedHistory &&
                                                                    deposittedHistory?.length > 0 ? (
                                                                    deposittedHistory?.map((row, index) => (
                                                                        <div className="single-card" key={index}>
                                                                            <div className="text">
                                                                                <p>Date & Time</p>
                                                                                <h6>
                                                                                    {formatTimestamp(row?.blockTimestamp)}
                                                                                </h6>
                                                                            </div>

                                                                            <div className="text">
                                                                                <p>Tx Hash</p>
                                                                                <a
                                                                                    href={`${arbiscan_url}/${row?.transactionHash}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {shortenAddress(row?.transactionHash)}
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                        <g clipPath="url(#clip0_7547_5119)">
                                                                                            <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            <path d="M10.5 1.5L6 6" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            <path d="M7.5 1.5H10.5V4.5" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                        </g>
                                                                                        <defs>
                                                                                            <clipPath id="clip0_7547_5119">
                                                                                                <rect width="12" height="12" fill="white" />
                                                                                            </clipPath>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </a>
                                                                            </div>

                                                                            <div className="text">
                                                                                <p>Amount</p>
                                                                                <h6>
                                                                                    $
                                                                                    {formatSmartDecimal(
                                                                                        +convertFromMweiToFIxed(row?.assets)
                                                                                    )}
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <p className="no-data-text">
                                                                        No Liquidity Deposits Yet
                                                                    </p>
                                                                )
                                                            ) : (
                                                                <p className="no-data-text" style={{ flexDirection: "column", gap: "25px" }}>
                                                                    <div className="box-svg">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                                                            <path d="M26.916 22.1667H26.9335" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M11.0833 11.0833H30.0833C30.9232 11.0833 31.7286 11.417 32.3225 12.0108C32.9164 12.6047 33.25 13.4101 33.25 14.25V30.0833C33.25 30.9232 32.9164 31.7286 32.3225 32.3225C31.7286 32.9164 30.9232 33.25 30.0833 33.25H7.91667C7.07681 33.25 6.27136 32.9164 5.6775 32.3225C5.08363 31.7286 4.75 30.9232 4.75 30.0833V7.91667C4.75 7.07681 5.08363 6.27136 5.6775 5.6775C6.27136 5.08363 7.07681 4.75 7.91667 4.75H30.0833" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </div>
                                                                    Connect your wallet
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane fade"
                                            id="nav-contact"
                                            role="tabpanel"
                                            aria-labelledby="nav-contact-tab"
                                        >
                                            <div className="table_side">
                                                {window.innerWidth > 991 ? (
                                                    <div className="history-section">
                                                        <div className="parent">
                                                            <div className="upper-fields">
                                                                <p>Timestamp</p>
                                                                <p>Transaction ID</p>
                                                                <p>Withdrawal Amount</p>
                                                                <p>Withdrawal Status</p>
                                                            </div>
                                                            <div
                                                                className="bottom-fields"
                                                                style={{ minHeight: "400px" }}
                                                            >
                                                                {!account ? (
                                                                    <p className="no-data-text" style={{ flexDirection: "column", gap: "25px" }}>
                                                                        <div className="box-svg">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                                                                <path d="M26.916 22.1667H26.9335" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                <path d="M11.0833 11.0833H30.0833C30.9232 11.0833 31.7286 11.417 32.3225 12.0108C32.9164 12.6047 33.25 13.4101 33.25 14.25V30.0833C33.25 30.9232 32.9164 31.7286 32.3225 32.3225C31.7286 32.9164 30.9232 33.25 30.0833 33.25H7.91667C7.07681 33.25 6.27136 32.9164 5.6775 32.3225C5.08363 31.7286 4.75 30.9232 4.75 30.0833V7.91667C4.75 7.07681 5.08363 6.27136 5.6775 5.6775C6.27136 5.08363 7.07681 4.75 7.91667 4.75H30.0833" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </div>
                                                                        Connect your wallet
                                                                    </p>
                                                                ) : !withdrawlHistory ||
                                                                    withdrawlHistory?.length === 0 ? (
                                                                    <p className="no-data-text">
                                                                        You Haven't Withdrawn Any Liquidity Yet
                                                                    </p>
                                                                ) : (
                                                                    withdrawlHistory?.map((row, index) => {
                                                                        const unlockTime = parseInt(row.blockTimestamp) + 120;
                                                                        const now = Math?.floor(Date.now() / 1000);
                                                                        const isLocked = now < unlockTime;


                                                                        return (
                                                                            <div className="single-field" key={index}>
                                                                                <h6 className="para-color">
                                                                                    {formatTimestamp(row?.blockTimestamp)}
                                                                                </h6>

                                                                                <a
                                                                                    href={`${arbiscan_url}/${row?.transactionHash}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {shortenAddress(row?.transactionHash)}
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                        <g clipPath="url(#clip0_7547_5119)">
                                                                                            <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            <path d="M10.5 1.5L6 6" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            <path d="M7.5 1.5H10.5V4.5" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                        </g>
                                                                                        <defs>
                                                                                            <clipPath id="clip0_7547_5119">
                                                                                                <rect width="12" height="12" fill="white" />
                                                                                            </clipPath>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </a>
                                                                                <h6 style={{ fontWeight: "400" }}>
                                                                                    $
                                                                                    {formatSmartDecimal(
                                                                                        +convertFromMweiToFIxed(row?.assets)
                                                                                    )}
                                                                                </h6>

                                                                                <div>
                                                                                    {row?.activeQueueLength > 0 && isLocked ? (
                                                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                                            <CountdownTimerLiquidity
                                                                                                setIsTimerExpired={() => refreshAllData()}
                                                                                                epochTime={unlockTime}
                                                                                            />

                                                                                            <OverlayTrigger
                                                                                                placement="top"
                                                                                                overlay={
                                                                                                    <TooltipCustom className="liquidity-provided-tooltip" id={`tooltip-${row.index}`}>
                                                                                                        <p>
                                                                                                            {t(
                                                                                                                "Your withdrawal is pending because the round is still active. You'll be able to claim it once the round finishes."
                                                                                                            )}
                                                                                                        </p>
                                                                                                    </TooltipCustom>
                                                                                                }
                                                                                            >
                                                                                                <svg
                                                                                                    style={{ cursor: "pointer" }}
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width="14"
                                                                                                    height="14"
                                                                                                    viewBox="0 0 14 14"
                                                                                                    fill="none"
                                                                                                >
                                                                                                    <g clipPath="url(#clip0_10136_49160)">
                                                                                                        <path
                                                                                                            d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z"
                                                                                                            stroke="#9F9F9F"
                                                                                                            strokeWidth="1.5"
                                                                                                            strokeLinecap="round"
                                                                                                            strokeLinejoin="round"
                                                                                                        />
                                                                                                        <path
                                                                                                            d="M7 9.33333V7"
                                                                                                            stroke="#9F9F9F"
                                                                                                            strokeWidth="1.5"
                                                                                                            strokeLinecap="round"
                                                                                                            strokeLinejoin="round"
                                                                                                        />
                                                                                                        <path
                                                                                                            d="M7 4.6665H7.01"
                                                                                                            stroke="#9F9F9F"
                                                                                                            strokeWidth="1.5"
                                                                                                            strokeLinecap="round"
                                                                                                            strokeLinejoin="round"
                                                                                                        />
                                                                                                    </g>
                                                                                                    <defs>
                                                                                                        <clipPath id="clip0_10136_49160">
                                                                                                            <rect width="14" height="14" fill="white" />
                                                                                                        </clipPath>
                                                                                                    </defs>
                                                                                                </svg>
                                                                                            </OverlayTrigger>
                                                                                        </div>
                                                                                    ) : row?.activeQueueLength > 0 || (pendingWitdrawStatus && pendingWitdrawAmount > 0 && index === 0) ? (
                                                                                        <button className="purple_button" onClick={() => handleShow(row?.index, row?.assets)}>
                                                                                            {t("Withdraw")}
                                                                                        </button>
                                                                                    ) : (
                                                                                        <button className="simple_button">
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width="14"
                                                                                                height="14"
                                                                                                viewBox="0 0 14 14"
                                                                                                fill="none"
                                                                                            >
                                                                                                <path
                                                                                                    d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                                                                                                    stroke="#212121"
                                                                                                    strokeWidth="1.5"
                                                                                                    strokeLinecap="round"
                                                                                                    strokeLinejoin="round"
                                                                                                />
                                                                                            </svg>
                                                                                            {t("Withdrawn")}
                                                                                        </button>
                                                                                    )}

                                                                                </div>

                                                                            </div>
                                                                        );
                                                                    })
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="history-section-mbl">
                                                        <div className="parent-cards">
                                                            {!account ? (
                                                                <p className="no-data-text" style={{ flexDirection: "column", gap: "25px" }}>
                                                                    <div className="box-svg">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                                                            <path d="M26.916 22.1667H26.9335" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M11.0833 11.0833H30.0833C30.9232 11.0833 31.7286 11.417 32.3225 12.0108C32.9164 12.6047 33.25 13.4101 33.25 14.25V30.0833C33.25 30.9232 32.9164 31.7286 32.3225 32.3225C31.7286 32.9164 30.9232 33.25 30.0833 33.25H7.91667C7.07681 33.25 6.27136 32.9164 5.6775 32.3225C5.08363 31.7286 4.75 30.9232 4.75 30.0833V7.91667C4.75 7.07681 5.08363 6.27136 5.6775 5.6775C6.27136 5.08363 7.07681 4.75 7.91667 4.75H30.0833" stroke="#DEDEDE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </div>
                                                                    Connect your wallet
                                                                </p>
                                                            ) : !withdrawlHistory ||
                                                                withdrawlHistory.length === 0 ? (
                                                                <p className="no-data-text">
                                                                    You Haven't Withdrawn Any Liquidity Yet
                                                                </p>
                                                            ) : (
                                                                withdrawlHistory?.map((row, index) => {
                                                                    const unlockTime =
                                                                        parseInt(row.blockTimestamp) + 120;
                                                                    const now = Math?.floor(Date?.now() / 1000);
                                                                    const locked =
                                                                        now < unlockTime && !isTimerExpired;

                                                                    return (
                                                                        <div className="single-card" key={index}>
                                                                            <div className="text">
                                                                                <p>Timestamp</p>
                                                                                <h6>
                                                                                    {formatTimestamp(row?.blockTimestamp)}
                                                                                </h6>
                                                                            </div>

                                                                            <div className="text">
                                                                                <p>Transaction ID</p>
                                                                                <a
                                                                                    href={`${arbiscan_url}/${row?.transactionHash}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {shortenAddress(row?.transactionHash)}
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                        <g clipPath="url(#clip0_7547_5119)">
                                                                                            <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            <path d="M10.5 1.5L6 6" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                            <path d="M7.5 1.5H10.5V4.5" stroke="#797979" strokeWidth="1.04" strokeLinecap="round" strokeLinejoin="round" />
                                                                                        </g>
                                                                                        <defs>
                                                                                            <clipPath id="clip0_7547_5119">
                                                                                                <rect width="12" height="12" fill="white" />
                                                                                            </clipPath>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </a>
                                                                            </div>

                                                                            <div className="text">
                                                                                <p>Withdrawal Amount</p>
                                                                                <h6>
                                                                                    $
                                                                                    {formatSmartDecimal(
                                                                                        +convertFromMweiToFIxed(row?.assets)
                                                                                    )}
                                                                                </h6>
                                                                            </div>
                                                                            <div className="text">
                                                                                <p>{t('Withdrawal Status')}</p>

                                                                                {row?.activeQueueLength && locked ? (
                                                                                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                                        <CountdownTimerLiquidity
                                                                                            setIsTimerExpired={
                                                                                                setIsTimerExpired
                                                                                            }
                                                                                            epochTime={unlockTime}
                                                                                        />
                                                                                        <OverlayTrigger
                                                                                            placement="top"
                                                                                            overlay={
                                                                                                <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                                                                    <p>{t('Your withdrawal is pending because the round is still active. You’ll be able to claim it once the round finishes.')}</p>
                                                                                                </TooltipCustom>
                                                                                            }
                                                                                        >
                                                                                            <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                                <g clip-path="url(#clip0_10136_49160)">
                                                                                                    <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                    <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                    <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                </g>
                                                                                                <defs>
                                                                                                    <clipPath id="clip0_10136_49160">
                                                                                                        <rect width="14" height="14" fill="white" />
                                                                                                    </clipPath>
                                                                                                </defs>
                                                                                            </svg>
                                                                                        </OverlayTrigger>
                                                                                    </div>
                                                                                ) : row?.activeQueueLength ? (
                                                                                    <button
                                                                                        className="purple_button"
                                                                                        onClick={() =>
                                                                                            handleShow(row?.index, row?.assets)
                                                                                        }
                                                                                    >
                                                                                        {t('Withdraw')}
                                                                                    </button>
                                                                                ) : (
                                                                                    <button className="simple_button">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <path d="M11.6673 3.5L5.25065 9.91667L2.33398 7" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </svg>
                                                                                        {t('Withdrawn')}
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>

            <Modal className="token liquiditymodal" show={show} onHide={handleClose} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Confirm Liquidity Withdrawal</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal">
                        <div className="inner_side_modal">
                            <h2>Withdrawal Amount</h2>
                            <h3>
                                ${withdrawalAmount}
                            </h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose}>
                                Close
                            </button>
                            <button className="Withdraw setbtnsizembl" onClick={() => { handleShow1(); handleClose(); }}>
                                Confirm
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show1} onHide={handleClose1} centered backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M33 14.5C33 19.4002 28.7942 23.4564 23.375 24.0494V27.875C23.375 28.2397 23.2301 28.5894 22.9723 28.8473C22.7144 29.1051 22.3647 29.25 22 29.25C21.6353 29.25 21.2856 29.1051 21.0277 28.8473C20.7699 28.5894 20.625 28.2397 20.625 27.875V22.75C20.625 22.3853 20.7699 22.0356 21.0277 21.7777C21.2856 21.5199 21.6353 21.375 22 21.375C26.5495 21.375 30.25 18.2916 30.25 14.5C30.25 10.7084 26.5495 7.625 22 7.625C17.4505 7.625 13.75 10.7084 13.75 14.5C13.75 14.8647 13.6051 15.2144 13.3473 15.4723C13.0894 15.7301 12.7397 15.875 12.375 15.875C12.0103 15.875 11.6606 15.7301 11.4027 15.4723C11.1449 15.2144 11 14.8647 11 14.5C11 9.1925 15.9345 4.875 22 4.875C28.0655 4.875 33 9.1925 33 14.5ZM22 33C21.4561 33 20.9244 33.1613 20.4722 33.4635C20.0199 33.7656 19.6675 34.1951 19.4593 34.6976C19.2512 35.2001 19.1967 35.7531 19.3028 36.2865C19.4089 36.8199 19.6709 37.3099 20.0555 37.6945C20.4401 38.0791 20.9301 38.341 21.4635 38.4472C21.997 38.5533 22.5499 38.4988 23.0524 38.2907C23.5549 38.0825 23.9844 37.7301 24.2865 37.2778C24.5887 36.8256 24.75 36.2939 24.75 35.75C24.75 35.0207 24.4603 34.3212 23.9445 33.8055C23.4288 33.2897 22.7293 33 22 33Z" fill="#DEDEDE" />
                                </svg>
                            </div>
                            <h2>Confirm Withdrawal</h2>
                            <h3>This action will submit a liquidity withdrawal request.</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose1}>Close</button>
                            <button className="Withdraw" onClick={onUnreserve}>Confirm</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show2} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Withdrawal Completed</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
                                    <path d="M39.063 11.7188L17.5795 33.2023L7.81421 23.4371" stroke="white" strokeWidth="2.70423" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2>Liquidity Withdrawal Completed</h2>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose2}>Done</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show3} onHide={handleClose3} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>{t('Request Liquidity Withdrawal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="new_modals">
                            <div className="liquid_textt">
                                <h2>{t('Withdrawal Amount')}</h2>
                                <h2>
                                    {t('Shares Available for Withdrawal')}:{" "}
                                    <span>{formatNumberWithCommasForRiskmarket(+userLiquidityShare)}</span>
                                </h2>
                            </div>
                            <div className="option-field">
                                <input
                                    className={+removeUserLiquidity > +userLiquidityShare && "error"}
                                    value={removeUserLiquidity}
                                    placeholder="0.00"
                                    type="number"
                                    id="fname"
                                    name="fname"
                                    onChange={(e) => setRemoveUserLiquidity(e.target.value)}
                                />
                                <a href="#" className="btn-max" onClick={(e) => {
                                    e.preventDefault();
                                    setRemoveUserLiquidity(+userLiquidityShare);
                                }}>MAX</a>
                            </div>
                            {+removeUserLiquidity > +userLiquidityShare && (
                                <h4 style={{ color: "var(--logout-text1)", fontSize: "12px", fontFamily: "hbold", lineHeight: "100%" }}>
                                    Amount exceeds available liquidity
                                </h4>
                            )}
                            <h5>Requested liquidity will be available for withdrawal after a 2-minutes lock-in period.</h5>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => { handleClose3(); setRemoveUserLiquidity(''); }}>Close</button>
                            <button
                                className="remove setbtnsizembl"
                                disabled={+removeUserLiquidity > +userLiquidityShare || removeUserLiquidity <= 0}
                                onClick={() => { handleShow4(); handleClose3(); }}
                            >
                                Request Withdrawal
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show4} onHide={handleClose4} centered backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M33 14.5C33 19.4002 28.7942 23.4564 23.375 24.0494V27.875C23.375 28.2397 23.2301 28.5894 22.9723 28.8473C22.7144 29.1051 22.3647 29.25 22 29.25C21.6353 29.25 21.2856 29.1051 21.0277 28.8473C20.7699 28.5894 20.625 28.2397 20.625 27.875V22.75C20.625 22.3853 20.7699 22.0356 21.0277 21.7777C21.2856 21.5199 21.6353 21.375 22 21.375C26.5495 21.375 30.25 18.2916 30.25 14.5C30.25 10.7084 26.5495 7.625 22 7.625C17.4505 7.625 13.75 10.7084 13.75 14.5C13.75 14.8647 13.6051 15.2144 13.3473 15.4723C13.0894 15.7301 12.7397 15.875 12.375 15.875C12.0103 15.875 11.6606 15.7301 11.4027 15.4723C11.1449 15.2144 11 14.8647 11 14.5C11 9.1925 15.9345 4.875 22 4.875C28.0655 4.875 33 9.1925 33 14.5ZM22 33C21.4561 33 20.9244 33.1613 20.4722 33.4635C20.0199 33.7656 19.6675 34.1951 19.4593 34.6976C19.2512 35.2001 19.1967 35.7531 19.3028 36.2865C19.4089 36.8199 19.6709 37.3099 20.0555 37.6945C20.4401 38.0791 20.9301 38.341 21.4635 38.4472C21.997 38.5533 22.5499 38.4988 23.0524 38.2907C23.5549 38.0825 23.9844 37.7301 24.2865 37.2778C24.5887 36.8256 24.75 36.2939 24.75 35.75C24.75 35.0207 24.4603 34.3212 23.9445 33.8055C23.4288 33.2897 22.7293 33 22 33Z" fill="#DEDEDE" />
                                </svg>
                            </div>
                            <h2>Confirm Withdrawal Request</h2>
                            <h3>This action will initiate a liquidity withdrawal request.</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => { handleClose4(); setRemoveUserLiquidity(''); }}>Close</button>
                            <button className="Withdraw" onClick={onRemoveLiquidity}>Confirm</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show5} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Withdrawal Request Submitted</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="25" viewBox="0 0 34 25" fill="none">
                                    <path d="M32.6014 1.35254L11.1178 22.8361L1.35254 13.0708" stroke="white" strokeWidth="2.70423" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2>Liquidity Withdrawal Request Submitted</h2>
                            <h5>Funds will become available for withdrawal after the 2-minutes lock-in period.</h5>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose5}>Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show6} onHide={handleClose6} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Add liquidity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="new_modals">
                            <div className="liquid_textt">
                                <h2>Liquidity Amount</h2>
                                <h2>
                                    Available Balance: <span>${smartAccountUsdtBalance ? formatNumbers(+smartAccountUsdtBalance) : 0}</span>
                                </h2>
                            </div>
                            <div className="relations">
                                <input
                                    placeholder="$0.00"
                                    type="number"
                                    id="fname"
                                    className={+liquidityAmount >= +smartAccountUsdtBalance && "error"}
                                    name="fname"
                                    value={liquidityAmount}
                                    onChange={(e) => setLiquidityAmount(e.target.value)}
                                />
                                <img src="/assets/poll/usdr.svg" alt="img" className="img-fluid neww_div" />
                            </div>
                            {+liquidityAmount >= +smartAccountUsdtBalance && (
                                <h4 style={{ color: "var(--logout-text1)", fontSize: "12px", fontFamily: "hbold", lineHeight: "100%" }}>
                                    Amount exceeds Available Balance
                                </h4>
                            )}
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => { handleClose6(); setLiquidityAmount(''); }}>Cancel</button>
                            <button
                                className="Withdraw setbtnsizembl disabled"
                                disabled={+liquidityAmount >= +smartAccountUsdtBalance || +liquidityAmount <= 0}
                                onClick={() => { handleShow7(); handleClose6(); }}
                            >
                                Add Liquidity
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show7} onHide={handleClose7} centered backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M33 14.5C33 19.4002 28.7942 23.4564 23.375 24.0494V27.875C23.375 28.2397 23.2301 28.5894 22.9723 28.8473C22.7144 29.1051 22.3647 29.25 22 29.25C21.6353 29.25 21.2856 29.1051 21.0277 28.8473C20.7699 28.5894 20.625 28.2397 20.625 27.875V22.75C20.625 22.3853 20.7699 22.0356 21.0277 21.7777C21.2856 21.5199 21.6353 21.375 22 21.375C26.5495 21.375 30.25 18.2916 30.25 14.5C30.25 10.7084 26.5495 7.625 22 7.625C17.4505 7.625 13.75 10.7084 13.75 14.5C13.75 14.8647 13.6051 15.2144 13.3473 15.4723C13.0894 15.7301 12.7397 15.875 12.375 15.875C12.0103 15.875 11.6606 15.7301 11.4027 15.4723C11.1449 15.2144 11 14.8647 11 14.5C11 9.1925 15.9345 4.875 22 4.875C28.0655 4.875 33 9.1925 33 14.5ZM22 33C21.4561 33 20.9244 33.1613 20.4722 33.4635C20.0199 33.7656 19.6675 34.1951 19.4593 34.6976C19.2512 35.2001 19.1967 35.7531 19.3028 36.2865C19.4089 36.8199 19.6709 37.3099 20.0555 37.6945C20.4401 38.0791 20.9301 38.341 21.4635 38.4472C21.997 38.5533 22.5499 38.4988 23.0524 38.2907C23.5549 38.0825 23.9844 37.7301 24.2865 37.2778C24.5887 36.8256 24.75 36.2939 24.75 35.75C24.75 35.0207 24.4603 34.3212 23.9445 33.8055C23.4288 33.2897 22.7293 33 22 33Z" fill="#DEDEDE" />
                                </svg>
                            </div>
                            <h2>Confirm Liquidity Addition</h2>
                            <h3>This action will add funds to the liquidity pool.</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => { handleClose7(); setLiquidityAmount(''); }}>Cancel</button>
                            <button className="Withdraw" onClick={onAddLiquidity}>Confirm</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show8} onHide={handleClose8} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Liquidity Added</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="25" viewBox="0 0 34 25" fill="none">
                                    <path d="M32.6014 1.35254L11.1178 22.8361L1.35254 13.0708" stroke="white" strokeWidth="2.70423" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2>Liquidity Added</h2>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose8}>Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show9} onHide={handleClose9} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Claim Rewards</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal">
                        <div className="inner_side_modal">
                            <h2>Claimable Amount</h2>
                            <h3>${userLiquidityWorth ? (+userLiquidityWorth)?.toFixed(4) : "0.00"}</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose9} disabled={loading}>Close</button>
                            <button className="Withdraw" onClick={onClaimRewards} disabled={+userLiquidityWorth === 0}>
                                Claim
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal" show={show10} centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="25" viewBox="0 0 34 25" fill="none">
                                    <path d="M32.6014 1.35254L11.1178 22.8361L1.35254 13.0708" stroke="white" strokeWidth="2.70423" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2>Rewards Claimed</h2>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose10}>Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Liquidity;